import { getCurrentDateInMDTFormat } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';

const generateDefaultProposalName = (groupName: string): string => {
  return `${groupName.trim()} - ${getCurrentDateInMDTFormat()}`;
};

export default generateDefaultProposalName;
